import React from 'react'
import styled from '@emotion/styled'
import { message, Upload } from 'antd'
import type { UploadProps } from 'antd'
import { Button } from 'app/(new-pages)/components/Button/pc/index.pc'
import { ReactComponent as CloudUploadIcon } from '../../images/svg/cloud-upload.svg'

import { maxFileSize, useUploadResumeContext } from './context'
import UploadResumeWrap from './Wrap.mobile'

const { Dragger } = Upload

const UploadMain = (props: { lang: any; userDetail: any }) => {
  const { lang = {}, userDetail } = props
  const { uploadResumeFile, fileData } = useUploadResumeContext()
  const profile = lang.profile || {}

  const uploadProps: UploadProps = {
    name: 'file',
    accept: '.pdf, .doc, .docx',
    multiple: false,
    showUploadList: false,
    beforeUpload: (file) => {
      if (file.size > maxFileSize) {
        message.error(profile?.uploadResumeModal?.errorTip)
        return false
      }
    },
    customRequest: (options) => {
      const resumeId = userDetail?.resume?.id || fileData?.data?.id
      uploadResumeFile({ ...options, resumeId: resumeId })
    }
  }

  const handleBack = () => {
    if (typeof window !== 'undefined') {
      window.history.back()
    }
  }

  return (
    <UploadResumeWrap
      {...props}
      footer={
        <FooterWrap>
          <BackButton onClick={handleBack}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 18 18'
              fill='none'
            >
              <path
                d='M5.25 13.5L1.5 9L5.25 4.5'
                stroke='#121212'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>{' '}
            <p className='countdownText'>{profile.back}</p>
          </BackButton>
        </FooterWrap>
      }
    >
      <ContentWrap>
        <div className='modal-content'>
          <Dragger {...uploadProps}>
            <div className='main-file-info'>
              <CloudUploadIcon />
              <Button variant='primaryBtn' btnSize='size40' className='main-btn-upload'>
                {profile?.uploadResumeModal?.uploadBtn}
              </Button>
              <div className='main-upload-desc'>{profile?.uploadResumeModal?.uploadDesc}</div>
            </div>
          </Dragger>
        </div>
      </ContentWrap>
    </UploadResumeWrap>
  )
}

const FooterWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 20px;
  background: #fff;
  z-index: 12;

  .footer-btns {
    display: flex;
    align-items: center;
    gap: 12px;
  }
`

const BackButton = styled.div`
  display: inline-flex;
  height: 44px;
  padding: 10px 10px 10px 0;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  p.countdownText {
    color: #111212;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
  }
`

const ContentWrap = styled.div`
  margin: 0 auto;

  .modal-content {
    text-align: center;
    padding-top: 24px;
    padding-bottom: 0;

    .ant-upload-wrapper .ant-upload-drag {
      border-radius: 16px;
      border: 3px dashed #ebeef0;
      background: #fdfdfd;
    }

    .ant-upload-wrapper .ant-upload-drag:not(.ant-upload-disabled):hover {
      border-color: #ebeef0;
    }
  }

  .main-file-info {
    display: flex;
    padding: 43px 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    border-radius: 4px;
    padding: 16px 0;

    .main-btn-upload {
      margin-top: 24px;
    }
    .main-upload-desc {
      margin-top: 12px;
      color: #111212;
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }
  }

  .progress-file-info {
    display: flex;
    margin-top: 32px;
    padding: 40px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    border-radius: 4px;
    border: 1px dashed #e4e4e4;
    background: #fcfcfc;
  }

  .progress-file-progress {
    width: 50%;
    margin: 24px 0;
  }

  .progress-file-message {
    color: #7d7d7d;
    text-align: center;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

export default UploadMain
